export enum CheckMethod {
  Equal = 'Equal',
  Less = 'Less',
  Larger = 'Larger',
  In = 'In',
}

export const CheckMethodMap = {
  [CheckMethod.Equal]: '等于',
  [CheckMethod.Less]: '小于',
  [CheckMethod.Larger]: '大于',
};
